import { z } from "zod";
const translationPath =
  "page.4uMarCom.automationRules.marcom_classifications.errors.";

const listClassificationSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "list_classification" }
);

export const classificationsSchema = z
  .object({
    id: z.string().optional(),
    listClassification: listClassificationSchema,
  })
  .superRefine((val, ctx) => {});

export type TClassificationsForm = z.infer<typeof classificationsSchema>;
